<template>
  <div>
    <div
      v-if="
        ($auth.policies['view-tuition-fee-group-list'] && type === 'normal') ||
          ($auth.policies['view-priority-group-list'] && type === 'priority')
      "
    >
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="route.meta.title"
            :link="[{ text: 'Tài chính', href: '#' }, { text: route.meta.title }]"
          />
        </div>
        <div class="flex-center">
          <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
            <v-icon left>mdi-file-excel</v-icon> Xuất Excel
          </v-btn>
          <v-btn
            v-if="
              ($auth.policies['add-new-tuition-fee-group'] && type === 'normal') ||
                ($auth.policies['add-new-priority-group'] && type === 'priority')
            "
            class="ml-6"
            depressed
            dark
            color="#0D47A1"
            @click="openDialog"
          >
            <v-icon left>add</v-icon>Thêm nhóm
          </v-btn>
        </div>
      </div>
      <v-card outlined class="pa-9 pr-3 mx-4 mb-6 elevation-0">
        <group-filter ref="groupFilter" :key="type" :type="type" />
      </v-card>
      <v-card outlined class="mx-4 elevation-0">
        <group-table :key="type" :type="type" ref="tuitionFeeGroupTable" />
      </v-card>
      <group-dialog @addGroupSuccess="addGroupSuccess" :type="type" action="create" ref="groupDialog" />
    </div>
    <div v-else>
      <Page403></Page403>
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import GroupFilter from '@/modules/tuitionFee/group/GroupFilter'
import GroupTable from '@/modules/tuitionFee/group/GroupTable'
import GroupDialog from '@/modules/tuitionFee/group/GroupDialog'
import { textHelpers } from '@/helpers/TextHelper.js'
import { mapActions, mapState } from 'vuex'
import Page403 from '@/views/Page403.vue'
import utils from '@/plugins/utils'
export default {
  components: {
    Breadcrumbs,
    GroupFilter,
    GroupTable,
    GroupDialog,
    Page403
  },
  computed: {
    ...mapState('tuitionFeeGroup', ['tuitionFeeGroups', 'tuitionFeeSearchParams']),
    route() {
      return this.$route
    },
    type() {
      if (this.route.name === 'TuitionFeeGroup') return 'normal'
      else return 'priority'
    }
  },
  methods: {
    ...mapActions('tuitionFeeGroup', ['fetchGroups']),
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = [...this.$refs.tuitionFeeGroupTable.headers]
        let excelHeader = headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'action')
        const list = await this.fetchGroups({
          ...this.tuitionFeeSearchParams,
          type: this.type,
          _sort: 'createdAt:desc',
          _limit: -1
        })
        const tuitionFeeGroups = JSON.parse(JSON.stringify(list))
        const data = tuitionFeeGroups.map(item => {
          item.category = textHelpers.getCategory(item.category)
          return item
        })
        utils.exportExcel(data, excelHeader, `Danh sách ${this.route.meta.title}`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    openDialog() {
      this.$refs.groupDialog.openDialog()
    },
    addGroupSuccess() {
      this.$refs.groupFilter.addGroupSuccess()
    }
  }
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
</style>
